module.exports = __webpack_public_path__ + "img/cl.4c39b330.png";